import { ThemeOptions } from "@mui/material";
import {
  generateErrorWarnInfoColors,
  MuiButton,
  MuiFilledInput,
  styleRootCommonAppBar,
  zeroBorderRadius
} from "./util/theme-generator-util";

export const bSmartsFamilyTitle = "Playfair";
export const bSmartsFontFamilyRegular = "Questrial";

export const bSmartsThemeConfig: ThemeOptions = {
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "primary" },
          style: () => ({
            color: "#FFFFFF",
            backgroundColor: "#79B943",
            fontWeight: 700,
            fontSize: 20,
            lineHeight: "24px",
            letterSpacing: "0.02em",
            "&:hover": {
              backgroundColor: "#79B943",
              "@media (hover: none)": {
                backgroundColor: "#79B943"
              }
            },
            "&:disabled": {
              color: "#FFFFFF",
              backgroundColor: "#79B943"
            }
          })
        },
        {
          props: { variant: "secondary" },
          style: {
            color: "#000000",
            backgroundColor: "#FFFFFF",
            border: "2px solid #000000",
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "24px",
            letterSpacing: "0.02em",
            "&:hover": {
              border: `2px solid #000000`,
              backgroundColor: "transparent",
              "@media (hover: none)": {
                border: `2px solid #000000`
              }
            },
            "&:disabled": {
              border: `2px solid rgba(0, 0, 0, 0.4)`
            }
          }
        }
      ],
      styleOverrides: MuiButton.styleOverrides
    },
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: zeroBorderRadius
  },
  palette: {
    primary: {
      main: "#4D1232"
    },
    secondary: {
      main: "#79B943"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#79B943"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: {
    fontFamily: bSmartsFontFamilyRegular,
    h1: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: bSmartsFamilyTitle,
      fontSize: "32px",
      lineHeight: "38px",
      letterSpacing: "normal"
    },
    h2: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: bSmartsFamilyTitle,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal"
    },
    h3: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: bSmartsFamilyTitle,
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "normal"
    },
    h4: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: bSmartsFamilyTitle,
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "normal"
    },
    subtitle1: {
      fontStyle: "normal",
      fontWeight: "400",
      fontFamily: bSmartsFamilyTitle,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal"
    },
    body1: {
      fontFamily: bSmartsFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px"
    },
    body2: {
      fontFamily: bSmartsFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "14px"
    },
    caption: {
      fontFamily: bSmartsFontFamilyRegular,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "16px"
    }
  }
};
